import { Modal, Form, Input, Button, message, Card, Descriptions } from "antd";
import React, { useEffect } from "react";
import { API_METHODS } from "../../../constants";
import useApi from "../../../hooks/useApi";

const { TextArea } = Input;

function RespondToInquiry({ visible, close, selectedInquiry }) {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  // API call for sending response
  const [response, request] = useApi();

  // Handle form submission
  const handleRespond = () => {
    form.validateFields().then((values) => {
      request(
        {
          admin_response: values.response_message,
        },
        API_METHODS.POST,
        `/admin/contact/respond/${selectedInquiry?.id}`
      );
    });
  };

  // Handle success response
  useEffect(() => {
    if (response.data && !response.isLoading) {
      messageApi.open({
        type: "success",
        content: selectedInquiry?.phone
          ? "Response saved successfully! WhatsApp message has been sent to the devotee."
          : "Response saved successfully! No phone number on this inquiry, so no WhatsApp message was sent.",
      });
      form.resetFields();
      close(true); // Refresh parent table
    }
  }, [response]);

  return (
    <Modal
      title="🙏 Respond to Inquiry"
      open={visible}
      onCancel={() => close(false)}
      width={700}
      footer={[
        <Button key="cancel" onClick={() => close(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={response.isLoading}
          onClick={handleRespond}
        >
          Send Response
        </Button>,
      ]}
    >
      {contextHolder}

      {/* Inquiry Details */}
      <Card
        title="Original Inquiry Details"
        size="small"
        style={{ marginBottom: "16px" }}
      >
        <Descriptions column={2} size="small">
          <Descriptions.Item label="Name">
            {selectedInquiry?.name}
          </Descriptions.Item>
          <Descriptions.Item label="Email">
            {selectedInquiry?.email}
          </Descriptions.Item>
          <Descriptions.Item label="Phone">
            {selectedInquiry?.phone || "Not provided"}
          </Descriptions.Item>
          <Descriptions.Item label="Date">
            {selectedInquiry?.created_on
              ? new Date(selectedInquiry.created_on).toLocaleDateString("en-IN")
              : ""}
          </Descriptions.Item>
          <Descriptions.Item label="Subject" span={2}>
            {selectedInquiry?.subject}
          </Descriptions.Item>
          <Descriptions.Item label="Message" span={2}>
            <div
              style={{
                maxHeight: "100px",
                overflowY: "auto",
                padding: "8px",
                background: "#f5f5f5",
                borderRadius: "4px",
                fontSize: "14px",
              }}
            >
              {selectedInquiry?.message}
            </div>
          </Descriptions.Item>
        </Descriptions>
      </Card>

      {/* Simple Response Form */}
      <Card title="Your Response">
        <Form form={form} layout="vertical">
          <Form.Item
            label="Response Message"
            name="response_message"
            rules={[
              { required: true, message: "Please enter your response" },
              { min: 5, message: "Response should be at least 5 characters" },
            ]}
          >
            <TextArea
              rows={5}
              placeholder="Enter your response message here...
This text is sent to the devotee on WhatsApp"
              maxLength={1000}
              showCount
            />
          </Form.Item>
        </Form>
      </Card>

      <div
        style={{
          padding: "12px",
          background: "#f0f9ff",
          borderRadius: "6px",
          fontSize: "13px",
          color: "#1890ff",
          marginTop: "16px",
        }}
      >
        {selectedInquiry?.phone ? (
          <>
            💬 Your response will be sent on WhatsApp to{" "}
            <strong>{selectedInquiry.phone}</strong>.The inquiry status will be updated automatically.
          </>
        ) : (
          <>
            💬 Responses are delivered on WhatsApp, but this devotee did not
            leave a phone number — the response will only be saved against the
            inquiry. The inquiry status will be updated automatically.
          </>
        )}
      </div>
    </Modal>
  );
}

export default RespondToInquiry;
